module.exports = __webpack_public_path__ + "static/media/Speakers-Day-2.a8fa98b3.jpg";